import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'googleMapsAddressRequest'
})
export class GoogleMapsAddressRequest implements PipeTransform {
  transform(line1: string, city: string, postalCode: string, country?: string) {
    return encodeURIComponent(
      StringHelper.join(
        [line1, StringHelper.join([city, postalCode], ' '), country],
        ', '
      )
    );
  }
}
